import { deleteRequest, get, post } from 'services/api';
import { SnippetValidationResponse } from 'modules/snippets/types';

export const FETCH_SNIPPETS_URL = '/i/snippets';
export const DELETE_SNIPPET_URL = '/templates/snippet';
export const SNIPPET_VALIDATION_URL = '/templates/snippetValidation';

export const getSnippets = () => get(FETCH_SNIPPETS_URL);

export const deleteSnippet = (snippetId: number) =>
  deleteRequest(`${DELETE_SNIPPET_URL}/${snippetId}`);

export const validateSnippet = (
  id: number | '',
  content: string,
  name: string,
  positionalParameters: string[],
): Promise<SnippetValidationResponse> =>
  post(SNIPPET_VALIDATION_URL, {
    name,
    content,
    positionalParameters,
    project: id,
  });
